'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.BaseInputButtonGroupNumber = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _BaseInput = require('./BaseInput');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactToolbox = require('@esnpm/react-toolbox');

var _index = require('./index');

var _reactLayoutComponents = require('react-layout-components');

var _redux = require('redux');

var _translate = require('@esnpm/translate');

var _Number = require('./Number');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classnames = require('classnames');
var BaseInputButtonGroupNumber = exports.BaseInputButtonGroupNumber = (_temp = _class = function (_BaseNumber) {
	_inherits(BaseInputButtonGroupNumber, _BaseNumber);

	function BaseInputButtonGroupNumber(props) {
		_classCallCheck(this, BaseInputButtonGroupNumber);

		return _possibleConstructorReturn(this, (BaseInputButtonGroupNumber.__proto__ || Object.getPrototypeOf(BaseInputButtonGroupNumber)).call(this, props));
	}

	_createClass(BaseInputButtonGroupNumber, [{
		key: 'handleOnChange',
		value: function handleOnChange(e) {
			e.preventDefault();
			var val = e.target.value;
			if (this.state.val != val) {
				this.setVal(val);
			}
		}

		// handleOnKeyDown(e) {
		// 	// console.log(this.props.allowedCharacters + "  " + e.key);
		// 	if (this.props.controlKeys.indexOf(e.key) == -1) {
		// 		let reg = RegExp(this.props.allowedCharacters);
		// 		if (!reg.test(e.key)) {
		// 			e.preventDefault();
		// 		}
		// 	} else {
		// 		console.log("123")
		// 		if (e.keyCode === 13) {
		// 			this.props.onEnter()
		// 		}
		// 	}
		// }


	}, {
		key: 'renderButton',
		value: function renderButton() {
			return _react2.default.createElement(
				_reactBootstrap.Button,
				{
					disabled: this.props.disabled,

					className: classnames("InputGroupButton", { disabled: this.props.disabled }),
					onClick: this.handleButton.bind(this),
					bsStyle: this.props.bsStyle
					// bsSize={"xs"}
				},
				this.renderIcon()
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				_reactLayoutComponents.Box,
				{ row: true, className: classnames("ESInput InputButtonGroupNumber", this.props.bsSize, this.props.bsStyle) },
				_react2.default.createElement(
					_reactLayoutComponents.Box,
					{ className: "PrefixButton" },
					this.props.btnLeft && this.renderButton()
				),
				_react2.default.createElement(
					_reactLayoutComponents.Box,
					{ className: classnames({
							"PrefixDiv": this.props.btnRight,
							"SuffixDiv": this.props.btnLeft
						}), fit: true },
					_react2.default.createElement(_index.ESInput.Number, this.props)
				),
				_react2.default.createElement(
					_reactLayoutComponents.Box,
					{ className: "SuffixButton" },
					this.props.btnRight && this.renderButton()
				)
			);
			// );
		}
	}, {
		key: 'handleButton',
		value: function handleButton() {
			this.props.onButtonClick(this.getRealValue());
		}
	}, {
		key: 'renderIcon',
		value: function renderIcon() {
			var Icon = this.props.icon;
			return _react2.default.createElement(Icon, null);
		}
	}]);

	return BaseInputButtonGroupNumber;
}(_Number.BaseNumber), _class.defaultProps = Object.assign({}, Number.defaultProps, {
	bsStyle: "default",
	bsSize: "sm",

	btnRight: true,
	btnLeft: false,

	icon: function icon() {},
	onButtonClick: function onButtonClick() {}

}), _class.propTypes = Object.assign({}, Number.propTypes, {
	bsStyle: _propTypes2.default.string,
	bsSize: _propTypes2.default.string,

	btnRight: _propTypes2.default.bool,
	btnLeft: _propTypes2.default.bool,

	icon: _propTypes2.default.func,
	onButtonClick: _propTypes2.default.func,

	min: _propTypes2.default.number,
	max: _propTypes2.default.number,
	step: _propTypes2.default.number
}), _temp);
exports.default = (0, _redux.compose)(_translate.withTrContext)(BaseInputButtonGroupNumber);